import { render, staticRenderFns } from "./PFormSwitch.vue?vue&type=template&id=3e8caa45&scoped=true"
import script from "./PFormSwitch.vue?vue&type=script&lang=ts"
export * from "./PFormSwitch.vue?vue&type=script&lang=ts"
import style0 from "./PFormSwitch.vue?vue&type=style&index=0&id=3e8caa45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8caa45",
  null
  
)

export default component.exports